import { render, staticRenderFns } from "./ProdExpFormDisabled.vue?vue&type=template&id=20f1db8c&scoped=true"
import script from "./ProdExpFormDisabled.vue?vue&type=script&lang=js"
export * from "./ProdExpFormDisabled.vue?vue&type=script&lang=js"
import style0 from "./ProdExpFormDisabled.vue?vue&type=style&index=0&id=20f1db8c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f1db8c",
  null
  
)

export default component.exports